<section
  class="custom-modal"
  [class.custom-modal--red]="modalTitleIconColor === iconColourEnum.red"
  tabindex="0"
  role="dialog"
  aria-modal="true"
  [attr.aria-labelledby]="modalTitle ? 'modal-title' : null">
  <header class="modal-header">
    <h2 id="modal-title" class="modal-title">
      {{ modalTitle }}
    </h2>

    @if (buttonCloseCross) {
      <button
        type="button"
        class="icon-button"
        aria-label="Close"
        (click)="onButtonPress('button-close')">
        <app-display-icon [icon]="icons.closeBoxOutline"></app-display-icon>
      </button>
    }
  </header>

  <div class="modal-body" [class.modal-body--scrollable]="modalBodyScrollable">
    @if (contextHeading) {
      <h3 class="context-heading">
        @if (modalTitleIcon) {
          <app-display-icon
            class="title-icon"
            [icon]="modalTitleIcon"
            [colour]="modalTitleIconColor">
          </app-display-icon>
        }
        <span [innerHTML]="formatContextText(contextHeading)"></span>
      </h3>
    }
    @if (contextDescription) {
      <ng-container class="context-description-container">
        @for (contextItem of contextDescription; track $index) {
          <section class="context-description">
            <div [innerHTML]="formatContextText(contextItem)"></div>
          </section>
        }
        @if (isImageVisible && imageUrl) {
          <figure
            class="image-wrapper">
            <img
              [ngSrc]="imageUrl"
              alt="Gallix Freshness Indicator Flow Chart"
              width="785"
              height="416"/>
          </figure>
        }
        @if (customContentComponent) {
          <ng-container
            *ngComponentOutlet="customContentComponent;
          injector: customContentInjector">
          </ng-container>
        }
      </ng-container>
    }
  </div>


  @if (buttonClose || buttonSecondary || buttonAccept) {
    <footer
      class="modal-footer">
      @if (buttonClose) {
        <app-shared-button
          class="secondary"
          [colour]="'primary'"
          (click)="onButtonPress('button-close')">
          {{ buttonCloseText }}
        </app-shared-button>
      }
      @if (buttonSecondary) {
        <app-shared-button
          [colour]="'primary'"
          (click)="onSecondaryButtonClick()">
          {{ buttonSecondaryText }}
        </app-shared-button>
      }
      @if (buttonAccept) {
        <app-shared-button
          [fill]="true"
          (click)="onButtonPress('button-accept')">
          {{ buttonAcceptText }}
        </app-shared-button>
      }
    </footer>
  }
</section>
